<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_rule.jpeg')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          プロモーション一般利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2025年11月20日
        </h2>
        <h3>
          1. 利用規約と条件：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              勝WINにご登録いただくお客様は、本利用規約に同意いただく必要があります。本規約および明示的に参照される文書は、当サイトとお客様との間における完全な合意を構成し、契約関係を規定します。
            </li>
            <li>
              当サイトをご利用になる前に、必ず本規約をお読みいただき、ご理解のうえご利用ください。万が一、本規約に同意いただけない場合は、当サイトの利用をお控えください。
            </li>
            <li>
              各種プロモーションの詳細は、告知またはプロモーションページ内で明示いたします。お客様がプロモーションに参加した時点で、当該規約に同意したものとみなします。
            </li>
          </ol>
        </div>
        <h3>
          2. ボーナス：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              「ボーナス」とは、お客様のボーナス残高に付与される資金またはその相当額を指し、直接出金はできず当サイトでの賭けにのみ使用可能な残高です。各プロモーションの規定（賭け条件など）を達成することで、現金残高へ変換され、出金が可能となります。
            </li>
            <li>
              【BONUSウォレット】<br>BONUSウォレットとは、当サイトの特定のプロモーションにおいて進呈されるボーナスマネーが保管されるウォレットを指します。この残高は直接出金することはできず、規定の賭け条件を達成することで現金ウォレット（JPY）へ変換されます。なお、本ウォレットは現金残高とは完全に区別される「分離型」として管理されます。現金ウォレット（JPY、仮想通貨）で入出金を行った時点で、BONUSウォレット内に残っているすべてのボーナス残高および勝利金は自動的に削除（放棄）されます。
            </li>
            <li>
              【キャッシュボーナス】<br>キャッシュボーナスとは、当サイトの特定のプロモーションにおいて指定された現金ウォレット（JPY、仮想通貨）に進呈・配布されるボーナスマネーを指します。
            </li>
            <li>
              【フリースピン】<br>フリースピンとは、当サイトの各種プロモーションにおいて進呈または配布される、特定のスロット内で無料でご利用いただけるスピンを指します。
            </li>
          </ol>
        </div>
        <h3>
          3. 賭け条件：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              「賭け条件」とは、ボーナスを現金残高へ変換するため、または入金された資金を出金可能にするために、お客様が当該入金額またはボーナス額に対して規定の倍率でベットを行う必要がある条件を指します。
            </li>
            <li>
              ボーナスを獲得していない場合でも、入金分には入金額の2倍の賭け条件が適用されます。
            </li>
            <li>
              各ボーナスに適用される賭け条件の倍率および詳細は、当該プロモーションページまたはオファーメールにて明示されるものとします。
            </li>
            <li>
              ボーナス獲得後は規定の賭け条件を達成するまで、ボーナスから得られたすべての勝利金は保留状態となり、いかなる理由においても削除・放棄・出金を行うことはできません。
            </li>
            <li>
              各ウォレットの賭け条件は、それぞれ独立して計算されます。
            </li>
            <li>
              ボーナスの利用有無にかかわらず、ウォレット残高が100円未満の状態で次にご入金を行った場合、未消化の古い賭け条件は自動的に消滅します。
            </li>
            <li>
              ウォレット残高が100円以上の状態でご入金いただく場合、未消化の賭け条件は消滅せず、保有中の賭け条件がそのまま累積して適用されます。
            </li>
            <li>
              ボーナス消滅前に複数のボーナスを獲得した場合、それぞれのボーナスに設定された賭け条件は合算して累積計算されます。
            </li>
            <li>
              お客様は賭け条件の進行状況をアカウント内で随時ご確認いただけます。賭け条件の管理およびその達成状況の把握は、すべてお客様ご自身の責任となります。なお、過去に受け取ったボーナスに付随する賭け条件が未消化のまま引き継がれていた場合や、お客様がそれを認識していない状態でプレイを行った場合であっても、当社はこれに起因するいかなる損失・不利益についても一切の責任を負いません。
            </li>
            <li>
              ボーナスが無効となった場合、当該ボーナスに関連する勝利金を含むすべてのボーナスマネーはアカウントから削除されます。
            </li>
          </ol>
        </div>
        <h3>
          4. 反映率：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              【BONUSウォレット】<br>
              BONUSウォレットの残高を利用する場合、賭け条件の消化率は以下の通り適用されます。
              <ol class="sub-list">
                <li>
                  スロットゲーム：100％
                </li>
                <li>
                  ライブカジノ：20％
                </li>
              </ol>
            </li>
            <li>
              【キャッシュボーナス】<br>
              特に別途記載のない場合、すべてのボーナス利用において、全ゲームのベット額は賭け条件に対して100％反映されるものとします。
            </li>
            <li>
              プロモーションにより対象外ゲーム、禁止ゲーム、または除外ゲームが指定されている場合、これらのゲームでのベットは賭け条件の消化に一切反映されず、またこれらのゲームでのプレイは禁止とします。
            </li>
          </ol>
        </div>
        <h3>
          5. 有効期限：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              有効期限を過ぎた場合、ボーナスは自動的に消滅するか、または当サイトは状況に応じて当該ボーナスおよび関連する勝利金を回収する権利を有します。
            </li>
            <li>
              【BONUS ウォレット】<br>
              プロモーション規約に特に別途記載がない限り、入金不要ボーナスの有効期限は付与後30日間です。また、当該ボーナスにかかる賭け条件も同期間内に達成する必要があります。
            </li>
            <li>
              【キャッシュボーナス】<br>
              プロモーション規約に特に別途記載がない限り、キャッシュボーナスの有効期限は付与後30日間です。また、当該ボーナスにかかる賭け条件も同期間内に達成する必要があります。
            </li>
            <li>
              【フリースピン】<br>
              プロモーション規約に特に別途記載がない限り、フリースピンの有効期限は付与後7日間です。
            </li>
          </ol>
        </div>
        <h3>
          6. 禁止・除外ゲーム：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              規定の禁止ゲームを利用した場合、規約違反となり、すべてのボーナスおよび関連する勝利金は無効となり、没収する権利を有します。
            </li>
            <li>
              【BONUS ウォレット】<br>
              BONUSウォレットの残高を利用する場合、以下のゲームは禁止ゲームとなります。
              <ol class="sub-list">
                <li>パチンコ・パチスロ</li>
                <li>クラッシュ</li>
                <li>ブラックジャック</li>
                <li>ルーレット</li>
                <li>Evolution社の「ファーストパーソン（First Person）」シリーズ全般</li>
              </ol>
            </li>
            <li>
              【キャッシュボーナス】<br>
              各プロモーションに適用される禁止・除外ゲームおよびその詳細は、当該プロモーションページまたはオファーメールにおいて明示されるものとします。
            </li>
            <li>
              【フリースピン】<br>
              プロモーション規約に特に別途記載がない限り、フリースピンで獲得した勝利金には禁止・除外ゲームの制限はなく、すべてのゲームに利用可能です。
            </li>
          </ol>
        </div>
        <h3>
          7. ベット額制限：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              規定のベット額制限を超える金額でベットした場合、規約違反となり、すべてのボーナスおよび関連する勝利金は無効となり、没収する権利を有します。
            </li>
            <li>
              【BONUS ウォレット】<br>
              BONUSウォレットの残高を利用する場合のベット額上限は以下の通りです。
              <ol class="sub-list">
                <li>スロット：1回あたり 625 JPY / 5 USD</li>
                <li>ライブカジノ：1回あたり 3,000 JPY / 20 USD</li>
              </ol>
            </li>
            <li>
              【キャッシュボーナス】<br>
              プロモーション規約に特に別途記載がない限り、キャッシュボーナスにはベット額制限はありません。ベット額制限が設定されている場合は、当該プロモーションページまたはオファーメールにて明示されます。
            </li>
            <li>
              【フリースピン】<br>
              プロモーション規約に特に別途記載がない限り、フリースピンで獲得した勝利金にはベット額制限はありません。ベット額制限が設定されている場合は、当該プロモーションページまたはオファーメールにて明示されます。
            </li>
          </ol>
        </div>
        <h3>
          8. 出金上限：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              ボーナスは、各プロモーションの規定（賭け条件など）を達成することで、現金残高へ変換され、出金が可能となります。また、プロモーションによっては、ボーナス利用時の出金上限が定められる場合があります。
            </li>
            <li>
              【BONUSウォレット】<br>
              各プロモーションに適用される出金上限は、当該プロモーションページまたはオファーメールにおいて明示されるものとします。
            </li>
            <li>
              【キャッシュボーナス】<br>
              プロモーション規約に特に別途記載がない限り、キャッシュボーナスには出金上限は設けられていません。出金上限が設定されている場合は、当該プロモーションページまたはオファーメールにて明示されるものとします。
            </li>
            <li>
              【フリースピン】<br>
              プロモーション規約に特に別途記載がない限り、フリースピンで獲得した勝利金には出金上限は設けられていません。出金上限が設定されている場合は、当該プロモーションページまたはオファーメールにて明示されるものとします。
            </li>
          </ol>
        </div>
        <h3>
          9. ボーナス乱用と禁止行為：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              出金申請の処理にあたりに限らず、当サイトは随時に取引、ゲーム履歴を調査する権利を有します。不正なゲームモードの利用、ボーナス乱用、違法なゲームプレイ、詐欺行為などに対しては一切寛容な対応をいたしません。
            </li>
            <li>
              以下の行為は、（下記に限定されるものではなく）明確な規約違反とみなされます：
              <ol class="sub-list">
                <li>
                  複数アカウント利用または第三者との共謀行為によって、ゲームの仕組みや機能を悪用し賭け条件を消化するまたは利益を得る行為
                </li>
                <li>
                  資金をゲーム内に隠蔽し、その後出金を目的として別途入金し、現金プレイで該当機種にて勝利金を獲得するような投機的な行為
                </li>
                <li>
                  ストック型スロット機種またはCollectボタンがある機種でフリースピンを貯め、その後出金を目的として別途入金し、現金プレイで該当機種にて勝利金を獲得するような投機的な行為
                </li>
                <li>
                  ルーレットにおける赤／黒の同時ベットや、バカラにおける プレイヤー／バンカーの同時ベットなど、オポジットベット（相反ベット）行為
                </li>
                <li>
                  第三者の外部ソフト／ツールを利用したプレイ行為
                </li>
                <li>
                  ベットを不正に増やすためにボーナスを利用する行為
                </li>
                <li>
                  VPN等を使用してIPアドレスを隠蔽し、リスクを軽減または排除するためにボーナスベットを繰り返す行為
                </li>
                <li>
                  ボーナストリガー操作：ボーナス発動条件を意図的に狙う行為
                </li>
              </ol>
            </li>
            <li>
              当サイトは、必要に応じてアカウントの調査を実施し、アカウントの利用制限や保留中の出金申請の停止を行う権利を留保いたします。
            </li>
            <li>
              調査結果が判明する前に、保留中の出金申請を含むすべての資金およびアカウント機能の利用を制限する権利を留保いたします。
            </li>
            <li>
              調査の結果、規約違反が確認された際には、ボーナスおよび勝利金は無効となり、サイトは資金の没収、プロモーション特典への参加資格の剥奪、ならびにアカウントの即時閉鎖を行う権利を当有します。
            </li>
          </ol>
        </div>
        <h3>
          10. 適用される法律およびその他の規定：
        </h3>
        <div class="terms-list">
          <ol class="list-type-decimal">
            <li>
              本利用規約は、コモロ諸島の法律に準拠します。お客様は、本利用規約に起因または関連して発生する紛争、論争、申し立てについて、コモロ諸島の裁判所の専属管轄に服することに同意するものとします。
            </li>
            <li>
              Lite Playerとしてご登録のお客様は、プロモーションに参加することはできません。
            </li>
            <li>
              当サイトは、重大な変更を含む本規約の内容を、事前の通知なく随時変更する権利を有します。変更後の規約は、当サイトに掲載された時点で効力を発生いたします。
            </li>
          </ol>
        </div>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/terms-and-conditions'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
<style>
.terms-list {
	font-size: 14.5px;
	line-height: 2;
}
.terms-list ol {
  margin-left: 20px;
}

.terms-list li {
  line-height: 2;
}

.sub-list {
  list-style-type: lower-roman; /* i, ii, iii... */
  margin-top: 12px;
  margin-left: 20px;
}
</style>
